import { OptimizePlanSignalRResult } from "./optimize-plan-signalR-result";

export class OptimizePlanSignalR {
    successful!: boolean;
    result!: OptimizePlanSignalRResult;
  }



  
  